// generated by @tcg/api-client gen-client — do not edit
import type { paths } from "./schema";
import { createServiceClient, type ServiceClientOptions } from "../../create-client";

export type PaymentsPaths = paths;
export const PAYMENTS_SERVICE = "payments" as const;

/** Typed openapi-fetch client for the payments service (schema `payments`). */
export function createPaymentsClient(options: ServiceClientOptions) {
  return createServiceClient<paths>("payments", options);
}

export type PaymentsClient = ReturnType<typeof createPaymentsClient>;
